<template>
  <div class="management">
    <h2>房客源管理</h2>
    <select v-model="house_client" @change="init">
      <option value="房源">房源</option>
      <option value="客源">客源</option>
    </select>
    <span class="add_one" @click="addOne">新增</span>

    <div class="houseList" v-show="house_client === '房源'">
      <div class="houseTop">
        <div class="item noBorderLeft">楼盘</div>
        <div class="item">幢座</div>
        <div class="item">单元</div>
        <div class="item">楼层</div>
        <div class="item">户型</div>
        <div class="item">面积</div>
        <div class="item">总价</div>
        <div class="item">单价</div>
      </div>
      <div v-for="item in houseList" :key="item.id" @dblclick="currentHouse = item" class="singleHouse">
        <div class="item noBorderLeft">{{item.realEstate.real_estate_name}}</div>
        <div class="item">{{item.build_num}}</div>
        <div class="item">{{item.unit}}</div>
        <div class="item">{{item.floor}}</div>
        <div class="item">{{item.room_count}}</div>
        <div class="item">{{item.square + 'm²'}}</div>
        <div class="item">{{item.price + '万'}}</div>
        <div class="item">{{(parseInt(item.price) * 10000 / Number(item.square)).toFixed(0) + '元/m²'}}</div>
      </div>
    </div>

    <div class="houseList" v-show="house_client === '客源'">
      <div class="houseTop">
        <div class="item noBorderLeft">姓名</div>
        <div class="item">位置</div>
        <div class="item">户型</div>
        <div class="item">面积</div>
        <div class="item">价位</div>
        <div class="item">来源</div>
        <div class="item">录入日</div>
      </div>
      <div v-for="item in clientList" :key="item.id" @dblclick="currentClient = item" class="singleHouse">
        <div class="item noBorderLeft">{{item.name + item.appellation}}</div>
        <div class="item">{{item.position}}</div>
        <div class="item">{{item.room_count}}</div>
        <div class="item">{{item.square}}</div>
        <div class="item">{{item.price}}</div>
        <div class="item">{{item.from}}</div>
        <div class="item">{{item.create_time.split(' ')[0]}}</div>
      </div>
    </div>

    <div class="mask" v-if="showAddHouse">
      <add-house @childOper="onChildOper"></add-house>
    </div>
    <div class="mask" v-if="currentHouse">
      <one-house @childOper="onChildOper" :item="currentHouse"></one-house>
    </div>
    <div class="mask" v-if="showAddClient">
      <add-client @childOper="onChildOper"></add-client>
    </div>
    <div class="mask" v-if="currentClient">
      <one-client @childOper="onChildOper" :item="currentClient"></one-client>
    </div>

  </div>
</template>

<script>
  import AddHouse from '@/components/AddHouse';
  import OneHouse from '@/components/OneHouse';
  import AddClient from '@/components/AddClient';
  import OneClient from '@/components/OneClient';

  export default {
    components: {
      AddHouse,
      OneHouse,
      AddClient,
      OneClient
    },
    data() {
      return {
        house_client: '房源',
        clientList: [],
        houseList: [],
        dblist: [],
        baseList: [],
        showdblist: [],
        page: 1,
        showAddHouse: false,
        showAddClient: false,
        currentHouse: null,
        currentClient: null
      }
    },
    beforeRouteEnter(to, from, next) {
      if(from.name === 'login') {
        to.meta.isBack = true;
      }
      next();
    },
    activated() {
      if(!this.$route.meta.isBack){
        let origin = this.$options.data();
        Object.assign(this.$data, origin)
        this.init();
      }
      this.$route.meta.isBack=false
    },
    methods: {
      init() {
        let that = this
        if (that.house_client === '房源') {
          that.$axios.get(that.$url_prefix + 'queryHouseList').then(function (res) {
            console.log('房源列表', res)
            that.houseList = res.data.data
          }).catch(function (res) {
            console.log('获取房源列表失败', res)
          })
        } else if (that.house_client === '客源') {
          that.$axios.get(that.$url_prefix + 'queryClientList').then(function (res) {
            console.log('客源列表', res)
            that.clientList = res.data.data
          }).catch(function (res) {
            console.log('获取客源列表失败', res)
          })
        }
      },

      addOne() {
        if (this.house_client === '房源') {
          this.showAddHouse = true
        } else {
          this.showAddClient = true
        }
      },
      onChildOper(data) {
        switch (data.from) {
          case 'addHouse':
            switch (data.oper) {
              case 'close':
                this.showAddHouse = false
                break
              case 'refresh':
                this.init()
                break
            }
            break
          case 'oneHouse':
            switch (data.oper) {
              case 'close':
                this.currentHouse = null
                break
              case 'refresh':
                this.init()
                break
            }
            break
          case 'addClient':
            switch (data.oper) {
              case 'close':
                this.showAddClient = false
                break
              case 'refresh':
                this.init()
                break
            }
            break
          case 'oneClient':
            switch (data.oper) {
              case 'close':
                this.currentClient = null
                break
              case 'refresh':
                this.init()
                break
            }
            break

        }
      },

    }
  }

</script>

<style scoped>
  .add_one {
    padding: 3px;
    border: 1px solid black;
    border-radius: 3px;
    font-size: 8px;
    margin-left: 5px;
  }
  .mask{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
  }
  .houseTop{
    display: flex;
    padding: 10px 20px;
    text-align: center;
    background-color: skyblue;
    margin-top: 10px;
  }
  .singleHouse{
    display: flex;
    border-bottom: 1px solid skyblue;
    padding: 10px 20px;
    text-align: center;
  }
  .item{
    flex-grow: 1;
    border-left: 1px solid skyblue;
    width: 0;
  }
  .noBorderLeft{
    border-left: none;
  }

  select{
    outline: none;
  }
</style>



// WEBPACK FOOTER //
// src/page/management.vue